import { render, staticRenderFns } from "./vModal.vue?vue&type=template&id=cb80245e&scoped=true"
import script from "./vModal.vue?vue&type=script&lang=ts"
export * from "./vModal.vue?vue&type=script&lang=ts"
import style0 from "./vModal.vue?vue&type=style&index=0&id=cb80245e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb80245e",
  null
  
)

export default component.exports